module.exports = __webpack_public_path__ + "static/media/upload_template.1d213e27.svg";